import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine_ic_refresh",
  "use": "icon-mine_ic_refresh-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-mine_ic_refresh\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path d=\"M21.627 22.828A11.621 11.621 0 0 1 14 25.667C7.556 25.667 2.333 20.443 2.333 14 2.333 7.556 7.556 2.333 14 2.333S25.667 7.556 25.667 14c0 2.492-.782 4.802-2.112 6.697L19.833 14h3.5a9.333 9.333 0 1 0-2.87 6.734l1.163 2.094Z\" fill=\"#0078FF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol